import { Body, Button } from '@e2n/ui/v2';
import { CreateAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateAbschnitt/CreateAbschnitt';
import { Abschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/Abschnitt';
import { Header } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/Header';
import { useRotationsplanById } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanById/useRotationsplanById';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import {
  ActionDrawer,
  ActionDropdownMenu,
} from '@/domain/mitarbeiter/features/rotationsplan/features/Details/ActionMenu';

export function Details() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { rotationsplan } = useRotationsplanById(id ?? '');

  return (
    <div className="flex flex-col gap-8 w-full min-w-0">
      <div className="flex flex-col gap-5 w-full min-w-0">
        <div className="flex justify-between items-start">
          <div className="flex gap-2 items-center">
            <Button asChild iconOnly variant="ghost-on-grey">
              <Link to={`/mitarbeiter/rotationsplaene/uebersicht`}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
            </Button>
            <Body weight="semibold">
              {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
            </Body>
          </div>
          {rotationsplan && (
            <>
              <div className="hidden sm:flex">
                <ActionDropdownMenu rotationsplan={rotationsplan} />
              </div>
              <div className="flex sm:hidden">
                <ActionDrawer rotationsplan={rotationsplan} />
              </div>
            </>
          )}
        </div>
        {rotationsplan && <Header rotationsplan={rotationsplan} />}
      </div>

      {!rotationsplan ? (
        <Body className="text-labels-secondary">
          {t('domain.mitarbeiter.rotationsplan.rotationsplaene.notFound')}
        </Body>
      ) : (
        <div className="flex flex-col gap-5 w-full min-w-0">
          {rotationsplan.abschnitte.map((abschnitt) => (
            <Abschnitt
              key={abschnitt.id}
              abschnitt={abschnitt}
              rotationsplan={rotationsplan}
            />
          ))}
          <CreateAbschnitt rotationsplan={rotationsplan} />
        </div>
      )}
    </div>
  );
}
